module.exports = __webpack_public_path__ + "static/img/calendar.d1ba2fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/calendar.png
// module id = sRQ+
// module chunks = 1